import { AuthParentComponent } from './authentication/auth-parent/auth-parent.component';
import { AuthenticationModule } from './authentication/authentication.module';
import { AdminDashboardComponent } from './doqfy-components/admin-dashboard/admin-dashboard.component';
import { CatEditParentComponent } from './doqfy-components/cat-edit/cat-edit-parent/cat-edit-parent.component';
import { CatEditModule } from './doqfy-components/cat-edit/cat-edit.module';
import { CatComposeParentComponent } from './doqfy-components/cat-compose/cat-compose-parent/cat-compose-parent.component';
import { CatComposeModule } from './doqfy-components/cat-compose/cat-compose.module';
import { CatExecutionModule } from './doqfy-components/cat-execution/cat-execution.module';
import { CatExecutionComponent } from './doqfy-components/cat-execution/cat-execution/cat-execution.component';
import { DashboardComponent } from './doqfy-components/dashboard/dashboard.component';
import { LandingPageComponent } from './doqfy-components/landing-page/landing-page.component';
import { ProfileParentComponent } from './doqfy-components/profile/profile-parent/profile-parent.component';
import { ProfileModule } from './doqfy-components/profile/profile.module';
import { UserManagementParentComponent } from './doqfy-components/user-management/user-management-parent/user-management-parent.component';
import { UserManagementModule } from './doqfy-components/user-management/user-management.module';
import { UserManagementEditorComponent } from './doqfy-components/user-management/user-management-editor/user-management-editor.component';
import { EStampParentComponent } from './doqfy-components/e-stamp/e-stamp-parent/e-stamp-parent.component';
import { EStampModule } from './doqfy-components/e-stamp/e-stamp.module';
import { ReportsModule } from './doqfy-components/reports/reports.module';
import { OrderDetailsModule } from './doqfy-components/order-details/order-details.module';
import { InventoryModule } from './doqfy-components/inventory/inventory.module';
import { ReportParentComponent } from './doqfy-components/reports/report-parent/report-parent.component';
import { OrderDetailsParentComponent } from './doqfy-components/order-details/order-details-parent/order-details-parent.component';
import { InventoryParentComponent } from './doqfy-components/inventory/inventory-parent/inventory-parent.component';
import { ESignParentComponent } from './doqfy-components/e-sign/e-sign-parent/e-sign-parent.component';
import { ESignModule } from './doqfy-components/e-sign/e-sign.module';
import { ViewAllOrderDetailsComponent } from './doqfy-components/view-all-order-details/view-all-order-details.component';
import { BulkUploadFormComponent } from './doqfy-components/bulk-upload/bulk-upload-form/bulk-upload-form.component';
import { BulkUploadModule } from './doqfy-components/bulk-upload/bulk-upload.module';
import { WalletParentComponent } from './doqfy-components/wallet/wallet-parent/wallet-parent.component';
import { WalletModule } from './doqfy-components/wallet/wallet.module';
import { RazorpayModule } from './doqfy-components/razorpay-transaction/razorpay.module';
import { ManagementParentComponent } from './doqfy-components/management/management-parent/management-parent.component';
import { ManagementModule } from './doqfy-components/management/management.module';
import { ProcurementParentComponent } from './doqfy-components/pre-procurement/procurement-parent/procurement-parent.component';
import { PreProcurementModule } from './doqfy-components/pre-procurement/pre-procurement.module';
import { SignLinkComponent } from './sign-link/sign-link.component';
import { AadhaarLinkComponent } from './sign-link/aadhaar-link/aadhaar-link.component';
import { AadhaarResponseComponent } from './sign-link/aadhaar-response/aadhaar-response.component';
import { AccountSettingsComponent } from './doqfy-components/profile/account-settings/account-settings.component';
import { AccountSettingGuard } from './doqfy-components/profile/account-settings/account-settings.guard';
import { RazorPayComponent } from './sign-link/razor-pay/razor-pay.component';
import { DscResponseComponent } from './sign-link/dsc-response/dsc-response.component';
import { ESignRetriggerComponent } from './doqfy-components/e-sign/e-sign-retrigger/e-sign-retrigger.component';
import { CommonLandingPageComponent } from './authentication/common-landing-page/common-landing-page.component';
import { RazorpayTransactionComponent } from './doqfy-components/razorpay-transaction/razorpay-transaction/razorpay-transaction.component';
import { SignFailedComponent } from './sign-link/sign-failed/sign-failed.component';
import { LoginComponent } from './authentication/login/login.component';
import { CyberarkComponent } from './cyberark/cyberark.component';
import { BulkUploadEstampParentComponent } from './doqfy-components/bulk-upload-pdf-estamp/bulk-upload-estamp-parent/bulk-upload-estamp-parent.component';
import { BulkUploadEstampModule } from './doqfy-components/bulk-upload-pdf-estamp/bulk-upload-estamp.module';
import { SecondVersionEsignComponent } from './sign-link/second-version-esign/second-version-esign.component';
import { HdfcCallbackComponent } from './sign-link/hdfc-callback/hdfc-callback.component';
import { JuspayCallbackComponent } from './sign-link/juspay-callback/juspay-callback.component';
import { ShareSignLinkComponent } from './sign-link/share-sign-link/share-sign-link.component';
import { ShareSignAuthGuard } from './sign-link/share-sign-link/share-sign-auth.guard';
import { ShareSignLinkDetailsComponent } from './sign-link/share-sign-link/share-sign-link-details/share-sign-link-details.component';
import { Routes } from '@angular/router';
import { SessionRedirectGuard } from './core/guards/session-redirect.guard';
import { RoleRedirectGuard } from './core/guards/role-redirect.guard';
import { NotFoundGuard } from './core/guards/not-found.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ReadPermissionGuard } from './core/guards/read-permission.guard';
import { DocxToHtmlConverterComponent } from './doqfy-components/docx-to-html-converter/docx-to-html-converter.component';
import { ContractImportDocumentsComponent } from './doqfy-components/bulk-upload/contract-import-documents/contract-import-documents.component';

const appRoutes: Routes = [
  {
    path: '',
    component: AuthParentComponent,
    loadChildren: () => AuthenticationModule,
    canActivate: [SessionRedirectGuard],
  },
  {
    path: 'doqfy',
    component: LandingPageComponent,
    children: [
      {
        path: '',
        canActivate: [RoleRedirectGuard],
        component: DashboardComponent,
      },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'profile',
        component: ProfileParentComponent,
        loadChildren: () => ProfileModule,
      },
      {
        path: 'userManagement',
        component: UserManagementParentComponent,
        loadChildren: () => UserManagementModule,
      },
      {
        path: 'userManagement-editor',
        component: UserManagementEditorComponent,
        loadChildren: () => UserManagementModule,
      },
      {
        path: 'cat-edit',
        component: CatEditParentComponent,
        loadChildren: () => CatEditModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Contract Edit' },
      },
      {
        path: 'cat-compose',
        component: CatComposeParentComponent,
        loadChildren: () => CatComposeModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Cat Compose' },
      },
      {
        path: 'cat-import',
        component: CatExecutionComponent,
        loadChildren: () => CatExecutionModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Contract Import' },
      },
      {
        path: 'e-stamp',
        component: EStampParentComponent,
        loadChildren: () => EStampModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'E-Stamp' },
      },
      {
        path: 'e-sign',
        component: ESignParentComponent,
        loadChildren: () => ESignModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'E-Sign' },
      },
      {
        path: 'bulk-upload-estamp',
        component: BulkUploadEstampParentComponent,
        loadChildren: () => BulkUploadEstampModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Automated Bulk Upload' },
      },
      {
        path: 'reports',
        component: ReportParentComponent,
        loadChildren: () => ReportsModule,
      },
      {
        path: 'orders',
        component: OrderDetailsParentComponent,
        loadChildren: () => OrderDetailsModule,
      },
      {
        path: 'inventory',
        component: InventoryParentComponent,
        loadChildren: () => InventoryModule,
      },
      { path: 'admin-dashboard', component: AdminDashboardComponent },
      {
        path: 'cat-edit',
        component: CatEditParentComponent,
        loadChildren: () => CatEditModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Contract Edit' },
      },
      {
        path: 'cat-compose',
        component: CatComposeParentComponent,
        loadChildren: () => CatComposeModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Cat Compose' },
      },
      {
        path: 'cat-execution',
        component: CatExecutionComponent,
        loadChildren: () => CatExecutionModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Contract Upload' },
      },
      { path: 'viewAllOrders', component: ViewAllOrderDetailsComponent },
      {
        path: 'edit-esign',
        component: ESignRetriggerComponent,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'E-Sign' },
      },
      {
      path: 'bulk-upload/contract-import-documents',
      component: ContractImportDocumentsComponent,
      canActivate: [ReadPermissionGuard],
      data: { permissionName: 'Contract Import' },
      },

      {
        path: 'bulk-upload',
        component: BulkUploadFormComponent,
        loadChildren: () => BulkUploadModule,
        canActivate: [ReadPermissionGuard],
        data: { permissionName: 'Contract Upload' },
      },
      {
        path: 'wallet',
        component: WalletParentComponent,
        loadChildren: () => WalletModule,
      },
      {
        path: 'razorpay',
        component: RazorpayTransactionComponent,
        loadChildren: () => RazorpayModule,
      },
      {
        path: 'management',
        component: ManagementParentComponent,
        loadChildren: () => ManagementModule,
      },
      {
        path: 'pre-procurement',
        component: ProcurementParentComponent,
        loadChildren: () => PreProcurementModule,
      },
      {
        path: 'account-setting',
        component: AccountSettingsComponent,
        loadChildren: () => ProfileModule,
        canDeactivate: [AccountSettingGuard], 
      },

    ],
  },
  {
    path: 'doc-to-html',
    component: DocxToHtmlConverterComponent,
  },
  {
    path: 'eSignLink',
    component: SignLinkComponent,
  },
  {
    path: 'aadhaarLink',
    component: AadhaarLinkComponent,
  },
  {
    path: 'aadhaarResponse',
    component: AadhaarResponseComponent,
  },
  {
    path: 'razorpay-callback',
    component: RazorPayComponent,
  },
  {
    path: 'juspay-callback',
    component: JuspayCallbackComponent,
  },
  {
    path: 'hdfc-callback',
    component: HdfcCallbackComponent,
  },
  {
    path: 'public-sign-link',
    component: ShareSignLinkComponent,
  },
  {
    path: 'public-sign-link/share-sign-link-details',
    component: ShareSignLinkDetailsComponent,
    canActivate: [ShareSignAuthGuard],
  },
  {
    path: 'dscResponse',
    component: DscResponseComponent,
  },
  {
    path: 'signFailed',
    component: SignFailedComponent,
  },
  {
    path: 'cyberark-login',
    component: CommonLandingPageComponent,
  },
  {
    path: 'v2-eSignLink',
    component: SecondVersionEsignComponent,
  },
  {
    path: 'v2-aadhaarLink',
    component: SecondVersionEsignComponent,
  },
  { path: 'cyberark', component: CyberarkComponent },
  {
    path: 'api-docs',
    loadComponent: () =>
      import('./api-documentation/api-documentation').then(
        (m) => m.ApiDocumentation,
      ),
    canActivate: [AuthGuard],
  },
  { path: '**', component: NotFoundComponent, canActivate: [NotFoundGuard] },
];

export default appRoutes;
